// IMPORTANT!
// fields that are meant to be sent to server must follow this convention:
// [type]_[server-field-name] ex. "cookie_name", "label_selector"
export const BASIC_INFO = 'basicInfo'
export const PRE_SCAN = 'preScan'
export const SCAN = 'scan'
export const POST_SCAN = 'postScan'

export const SCAN_NAME_FIELD = 'scan_name'
export const RESTRICTIONS_FIELD_NAME = 'restrictions_restrictions'
export const ALL_SUB_DOMAINS_FIELD = 'all_sub_domains'
export const MOBILE_VIEWPORT = 'mobile_viewport'
export const PRE_SCAN_SELECTION = 'preScanSelection'
export const COOKIES = 'cookies'
export const COOKIE_NAME_FIELD = 'cookie_name'
export const COOKIE_VALUE_FIELD = 'cookie_value'
export const COOKIE_DOMAIN_FIELD = 'cookie_domain'
export const LABELS = 'labels'
export const LABEL_NAME_FIELD = 'label_label'
export const LABEL_SELECTOR_FIELD = 'label_selector'
export const FLOWS = 'flows'
export const FLOW_NAME_FIELD = 'flow_name'
export const FLOW_ACTIONS = 'flow_actions'
export const WEBHOOKS = 'webhooks'
export const WEBHOOK_METHOD_TYPE_FIELD = 'webhook_method'
export const WEBHOOK_NAME_FIELD = 'webhook_name'
export const WEBHOOK_BODY_FIELD = 'webhook_body'
export const WEBHOOK_URL_FIELD = 'webhook_url'
export const WEBHOOK_HEADERS = 'webhook_headers'
export const WEBHOOK_HEADER_NAME = 'webhookHeader_name'
export const WEBHOOK_HEADER_VALUE = 'webhookHeader_value'
export const SCAN_TYPE_FULL = 'full'
export const SCAN_TYPE_CUSTOM = 'custom'
export const SCAN_TYPE_FLOW = 'flow'
export const SCAN_TYPE = 'scanType'
export const FULL_SCAN_ROOT_URL_FIELD = 'fullScan_root_url'
export const FULL_SCAN_COUNT_FIELD = 'fullScan_count'
export const CUSTOM_SCAN_FIELD = 'customScan_pages'
export const SCAN_U_REMEDIATE_FIELD = 'uRemediate'
export const SCAN_PARAMETERS_FLAG_FIELD = 'prefix_enable_parameters'
export const SCAN_PARAMETERS = 'enable_parameters'
export const BASE_ADDRESS_KEY = '$BASE_ADDRESS'
export const RULES = 'rules'
export const RULE_NAME = 'rule_name'
export const RULE_FILTERS = 'filters'
export const FILTER_NAME = 'filter_name'
export const FILTER_TYPE = 'filter_type'
export const FILTER_PROPERTIES = 'filter_properties'
export const FILTER_CONDITION = 'filter_condition'
export const FILTER_PROPERTY_CONDITION = 'condition'
export const FILTER_PROPERTY_TYPE = 'type'
export const FILTER_PROPERTY_VALUE = 'value'
export const FILTER_VALUE = 'filter_value'
export const FILTER_TYPE_SCAN = "scan"
export const RULE_TRIGGER = 'rule_condition'
export const RULE_ACTION_TYPE = 'rule_action_types'
export const RULE_ACTIONS = 'rule_actions'
export const RULE_ACTION_TYPE_EMAIL = 'mail'
export const RULE_ACTION_TYPE_WEBHOOK = 'webhook'
export const RULE_ACTION_EMAIL_VALUE = 'ruleActionMailRuleAction_to'
export const SCAN_PREFIX = 'scan-'
export const FLOW_PREFIX = 'flow-'
export const RULE_PREFIX = 'rule-'
export const USER_KEYS = ['id', 'name']
export const NEW_PREFIX = "new_"
export const COOKIE_KEYS = [COOKIE_NAME_FIELD, COOKIE_VALUE_FIELD, COOKIE_DOMAIN_FIELD]
export const LABEL_KEYS = [LABEL_NAME_FIELD, LABEL_SELECTOR_FIELD]
export const FLOW_KEYS = [FLOW_NAME_FIELD, FLOW_ACTIONS, SCAN_PARAMETERS_FLAG_FIELD]
export const WEBHOOK_KEYS = [
	WEBHOOK_NAME_FIELD,
	WEBHOOK_METHOD_TYPE_FIELD,
	WEBHOOK_URL_FIELD,
	WEBHOOK_BODY_FIELD,
	WEBHOOK_HEADERS
]
export const RULES_KEYS = [RULE_TRIGGER, RULE_NAME, RULE_ACTIONS]
export const RULE_WEBHOOK_PREFIX = [`${RULE_PREFIX}${WEBHOOKS}`];
export const FULL_SCAN_KEYS = [FULL_SCAN_ROOT_URL_FIELD, FULL_SCAN_COUNT_FIELD, SCAN_PARAMETERS_FLAG_FIELD]
export const FLOW_SCAN_KEYS = [`${SCAN_PREFIX}${FLOW_NAME_FIELD}`, `${SCAN_PREFIX}${FLOW_ACTIONS}`, SCAN_PARAMETERS_FLAG_FIELD]
export const FILTER_KEYS = [FILTER_NAME, FILTER_TYPE, FILTER_PROPERTIES, FILTER_CONDITION, FILTER_VALUE]
export const RULE_WEBHOOK_KEYS = [
	WEBHOOK_NAME_FIELD,
	WEBHOOK_METHOD_TYPE_FIELD,
	WEBHOOK_URL_FIELD,
	WEBHOOK_BODY_FIELD,
	WEBHOOK_HEADER_NAME,
	WEBHOOK_HEADER_VALUE
]

export const SUCCESS = "success";




